import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';
import { LinkedInPopUp } from 'react-linkedin-login-oauth2';
import { logout } from './actions/accountActions';

export function routesConfig(productType) {
  return [
    {
      exact: true,
      path: '/',
      component: () => (
        <Redirect
          to={
            productType === 'Precisa'
              ? '/precisa'
              : `${productType.toLowerCase()}`
          }
        />
      )
    },
    {
      exact: true,
      path: '/404',
      component: lazy(() => import('src/views/pages/Error404View'))
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/login',
      component: lazy(() => import('src/views/auth/LoginView'))
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/clientVerification',
      component: lazy(() => import('src/views/auth/clientVerification'))
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/linkedin',
      component: LinkedInPopUp
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/superadmin/login',
      component: lazy(() => import('src/views/auth/LoginView'))
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/forgot',
      component: lazy(() => import('src/views/auth/ForgotPasswordView'))
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/validateResetPassword',
      component: lazy(() => import('src/views/auth/ResetPasswordView'))
    },
    {
      exact: true,
      path: '/login-unprotected',
      component: lazy(() => import('src/views/auth/LoginView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/free',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/professional',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/professional/gstrPlanType',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/professional/cicPlanType',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/payPerUse',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/payPerUse/gstrPlanType',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/register/payPerUse/cicPlanType',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/emailVerification',
      component: lazy(() =>
        import('src/views/auth/RegisterView/EmailVerification')
      )
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/contactSales',
      component: lazy(() => import('src/views/Contact/SalesContact'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/contactUs',
      component: lazy(() => import('src/views/Contact/SalesContact'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: `/${productType.toLowerCase()}/contactUs`,
      component: lazy(() => import('src/views/Contact/SalesContact'))
    },
    {
      exact: true,
      guard: GuestGuard,
      layout: MainLayout,
      path: '/contactSupport',
      component: lazy(() => import('src/views/Contact/SupportContact'))
    },
    {
      exact: true,
      path: '/register-unprotected',
      component: lazy(() => import('src/views/auth/RegisterView'))
    },
    {
      exact: true,
      path: '/apis',
      component: lazy(() => import('src/views/ApiDocView'))
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/ppuPayment',
      component: lazy(() =>
        import('src/views/ManageSubscriptionView/FreeToPPUEmail')
      )
    },
    {
      exact: true,
      layout: MainLayout,
      path: '/gstnLogin',
      component: lazy(() =>
        import('src/views/reports/NewReportView/GstinLoginView')
      )
    },
    {
      path: `/${productType.toLowerCase()}`,
      guard: AuthGuard,
      layout: DashboardLayout,
      routes: [
        {
          exact: true,
          path: `/${productType.toLowerCase()}/home`,
          component: lazy(() => import('src/views/HomeView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}`,
          component: () => (
            <Redirect
              to={
                productType === 'Precisa'
                  ? '/precisa/home'
                  : `/${productType.toLowerCase()}/home`
              }
            />
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/reports`,
          component: lazy(() => import('src/views/reports/ReportListView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/createReport`,
          component: lazy(() => import('src/views/reports/NewReportView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/analysis/:refId`,
          component: lazy(() => import('src/views/AnalysisView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/analysis/editReportType/:refId`,
          component: lazy(() => import('src/views/AnalysisView/index'))
        },
        {
          exact: true,
          path: `${productType.toLowerCase()}/bankStatement`,
          component: lazy(() => import('src/views/reports/PdfView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/users`,
          component: lazy(() =>
            import('src/views/ManageUsersView/UsersListView')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/createUser`,
          component: lazy(() =>
            import('src/views/ManageUsersView/CreateUserView')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/editUser/:id`,
          component: lazy(() =>
            import('src/views/ManageUsersView/EditUserView')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/changePassword`,
          component: lazy(() => import('src/views/auth/ChangePasswordView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/subscription`,
          component: lazy(() =>
            import('src/views/ManageSubscriptionView/SubscriptionHomeView')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/subscription/changePlan`,
          component: lazy(() =>
            import('src/views/ManageSubscriptionView/ChangePlan')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/subscription/topUpCurrentPlan`,
          component: lazy(() =>
            import('src/views/ManageSubscriptionView/MakePayment/index')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/subscription/changePrimaryContact`,
          component: lazy(() =>
            import('src/views/ManageSubscriptionView/ChangePrimaryContactView')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/subscription/cancelSubscription`,
          component: lazy(() =>
            import('src/views/ManageSubscriptionView/CancelSubscription')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/subscription/renewSubscription`,
          component: lazy(() =>
            import('src/views/ManageSubscriptionView/RenewSubscription')
          )
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/newSubscription`,
          component: lazy(() => import('src/views/NewSubscriptionView'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/contactSales`,
          component: lazy(() => import('src/views/Contact/SalesContact'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/contactSales/fromChangePlan`,
          component: lazy(() => import('src/views/Contact/SalesContact'))
        },
        {
          exact: true,
          path: `/${productType.toLowerCase()}/contactSupport`,
          component: lazy(() => import('src/views/Contact/SupportContact'))
        },
        {
          component: () => <Redirect to="/404" />
        }
      ]
    }
  ];
}
